import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { CustomSnackbarService } from '../../components/custom-snackbar/custom-snackbar.service';
import { IHDErrorResponse } from '../../interfaces/IHDdata';
import {
  ALPHA_MSG,
  ALREADY_EXISTS_MSG,
  CHARACTERS_LONG_MSG,
  CODE_NOT_FOUND,
  DISPENSE_LOADING,
  DISPENSE_ORDERED,
  DISPENSE_READY,
  DISPENSE_STATES,
  SnackType,
  VIEW_TYPES,
} from '../../utils/constants';
import { CODE_VALIDATE_ERRORS } from '../helmsdeep/helmsdeep-validate-code-error.response';

@Injectable({
  providedIn: 'root',
})
export class ApiErrorHandlerService {
  private errorMessage = 'common.processingError';
  private orderIdInUseMessage = 'common.orderIdInUseMsg';
  private orderNotReadyForPickupMessage = 'common.orderNotReadyForPickup';
  private seeAttendantMessage = 'common.seeAttendantMsg';
  private orderIdLengthMessage = 'common.orderIdLengthMsg';
  private orderIdNumbersMessage = 'common.orderIdNumbersMsg';
  private seeAssociateMessage = 'ttw.seeAssociateMsg';
  private invalidCodeMessage = 'common.invalidCodeMsg';

  constructor(private customSnackbarService: CustomSnackbarService, private router: Router) {}

  handleApiError(error: any, customMessage: string): void {
    console.log(error, customMessage);
    const customMsg = customMessage || this.errorMessage;
    this.customSnackbarService.openSnackBar(customMsg, 'Error');
  }

  showMessage(message: string, messageType: SnackType, duration?: number): void {
    this.customSnackbarService.openSnackBar(message, messageType, duration);
  }

  getErrorMessage(error): void {
    const message = error.error ? this.handlingErrorMessage(error.error) : '';
    this.handleApiError(error, message);
  }

  handlingErrorMessage(errorObject: IHDErrorResponse): string {
    let returnMessage: string;
    switch (true) {
      case errorObject.title.includes(ALREADY_EXISTS_MSG):
        returnMessage = this.orderIdInUseMessage;
        break;

      case errorObject.title.includes(CHARACTERS_LONG_MSG):
        returnMessage = this.orderIdLengthMessage;
        break;

      case errorObject.title.includes(ALPHA_MSG):
        returnMessage = this.orderIdNumbersMessage;
        break;

      case this.messageNotReadyForPickup(errorObject):
        returnMessage = this.orderNotReadyForPickupMessage;
        break;

      case errorObject.title.includes(DISPENSE_STATES.LOCKEDDOWN):
        returnMessage = this.seeAttendantMessage;
        break;

      case errorObject.title.includes(DISPENSE_STATES.LOADED_VERIFY):
        returnMessage = this.seeAssociateMessage;
        break;

      case (
        [CODE_VALIDATE_ERRORS.CODE_NOT_FOUND, CODE_VALIDATE_ERRORS.INVALID_STATE] as string[]
      ).includes(errorObject.title):
        returnMessage = this.invalidCodeMessage;
        break;

      default:
        returnMessage = errorObject.title;
        break;
    }
    return returnMessage;
  }

  messageNotReadyForPickup(errorObject: IHDErrorResponse): boolean {
    const url = this.router.routerState.snapshot.url.split('/')[1];
    const isTTW: boolean = url === VIEW_TYPES.TTW;
    const codeNotFound: boolean = errorObject.title.includes(CODE_NOT_FOUND);
    const dispenseTypes = [DISPENSE_ORDERED, DISPENSE_READY, DISPENSE_LOADING];
    const errorTypeMatching: boolean = errorObject.type
      ? dispenseTypes.some((dispenseType) => errorObject.type.includes(dispenseType))
      : false;
    return isTTW && (codeNotFound || errorTypeMatching);
  }
}
